module.exports = __webpack_public_path__ + "static/media/decade-grid-2.51e41417.png";